import { SlugFilters } from './slugGenerator';
import { VALUE_TO_FILTER_TYPE_CONFIG } from '@configs/filterType.config';

export const FILTER_TYPE_PRIORITY: (keyof SlugFilters)[] = [
  'brand',
  'bodyType',
  'fuelType',
  'transmission',
  'budget',
  'seatingCapacity',
  'features'
];

export const FILTER_TYPE_POSITIONS = FILTER_TYPE_PRIORITY.reduce((acc, type, index) => {
  acc[type] = index;
  return acc;
}, {} as Record<keyof SlugFilters, number>);

export const getFilterPosition = (value: string): number => {
  const filterType = getFilterType(value);
  return filterType ? FILTER_TYPE_POSITIONS[filterType] : -1;
};

export const getFilterType = (value: string): keyof SlugFilters | undefined => {
  return VALUE_TO_FILTER_TYPE_CONFIG[value.toLowerCase()];
}; 